import { render, staticRenderFns } from "./ChatAudioMessage.vue?vue&type=template&id=c79a8800&scoped=true&lang=pug&"
import script from "./ChatAudioMessage.vue?vue&type=script&lang=js&"
export * from "./ChatAudioMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatAudioMessage.vue?vue&type=style&index=0&id=c79a8800&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79a8800",
  null
  
)

export default component.exports